export const CUSTOMER_OPTIONS = {
  DTA: 1,
  LPH: 2,
  TCS: 3,
  TCR: 4,
  UND: 5, // use new dashboard
};
